import { createSlice } from '@reduxjs/toolkit'

const FETCH_ALL_DATA_KEY = 'fetch_all_data_mode'

interface FetchAllDataState {
	enabled: boolean
	currentAccountId: number | null
}

const initialState: FetchAllDataState = {
	enabled: localStorage.getItem(FETCH_ALL_DATA_KEY) === 'true',
	currentAccountId: null,
}

const fetchAllDataSlice = createSlice({
	name: 'fetchAllData',
	initialState,
	reducers: {
		enableFetchAllData: (state) => {
			state.enabled = true
			localStorage.setItem(FETCH_ALL_DATA_KEY, 'true')
		},
		disableFetchAllData: (state) => {
			state.enabled = false
			localStorage.removeItem(FETCH_ALL_DATA_KEY)
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			(action) => action.type === 'auth/loginSuccess',
			(state, action: any) => {
				const hasDefault = action.payload?.user?.account?.features?.includes(
					'fetch_all_data_default'
				)
				state.enabled = !!hasDefault
				state.currentAccountId = action.payload?.user?.account?.id ?? null
				if (hasDefault) {
					localStorage.setItem(FETCH_ALL_DATA_KEY, 'true')
				} else {
					localStorage.removeItem(FETCH_ALL_DATA_KEY)
				}
			}
		)
		builder.addMatcher(
			(action) => action.type === 'auth/logout',
			(state) => {
				state.enabled = false
				state.currentAccountId = null
				localStorage.removeItem(FETCH_ALL_DATA_KEY)
			}
		)
		builder.addMatcher(
			(action) => action.type === 'selectedAccount/setSelectedAccount',
			(state, action: any) => {
				if (action.payload) {
					const newAccountId = action.payload.id ?? null
					// Only reset the toggle when switching to a different account.
					// Refreshing data for the same account should not override the
					// user's explicit toggle choice.
					if (newAccountId !== state.currentAccountId) {
						const hasDefault = action.payload.features?.includes(
							'fetch_all_data_default'
						)
						state.enabled = !!hasDefault
						if (hasDefault) {
							localStorage.setItem(FETCH_ALL_DATA_KEY, 'true')
						} else {
							localStorage.removeItem(FETCH_ALL_DATA_KEY)
						}
						state.currentAccountId = newAccountId
					}
				}
			}
		)
		builder.addMatcher(
			(action) => action.type === 'selectedAccount/clearSelectedAccount',
			(state) => {
				state.currentAccountId = null
			}
		)
	},
})

export const { enableFetchAllData, disableFetchAllData } =
	fetchAllDataSlice.actions

export const fetchAllDataReducer = fetchAllDataSlice.reducer
